<template>
  <div>
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseInfoData"
            :columns="baseColumns"
            :rules="baseRules"
            :isQueryPanel="false"
            :isDisabledForm="disableBaseFormData"
            labelWidth="150px"
            @changeMethod="changeMethod"
          ></SiruiSearch>
          <!-- 预警提醒 -->
          <el-form
            :model="form"
            ref="fromRef"
            label-width="120px"
            class="demo-ruleForm"
            size="small"
            style="padding-right: 10px"
            :disabled="disableBaseFormData"
          >
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item style="">
                  <template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span style="color: red">预警提醒</span>
                    </el-tooltip>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="最晚提货日" prop="latestPickUpDate"
                  ><template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText1>propLength }">最晚提货日</span>
                      <div slot="content" v-html="tipText1"></div>
                    </el-tooltip>
                  </template>
                  <el-date-picker
                    type="date"
                    v-model="form.latestPickUpDate"
                    format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择最晚提货日"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="最晚应收结算日" prop="latestReceivableSettlementFate">
                  <inputNumber
                    v-model="form.latestReceivableSettlementFate"
                    :controls="false"
                    class="inputWidth"
                    :precision="2"
                    append="天"
                    :min="-99999999999999999"
                    :max="99999999999999999"
                  ></inputNumber>
                  <template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText2>propLength }">最晚应收结算日</span>
                      <div slot="content" v-html="tipText2"></div>
                    </el-tooltip>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="最晚开票日" prop="latestInvoiceFate">
                  <inputNumber
                    v-model="form.latestInvoiceFate"
                    :controls="false"
                    class="inputWidth"
                    :precision="2"
                    append="天"
                    :min="-99999999999999999"
                    :max="99999999999999999"
                  ></inputNumber>
                  <template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText1>propLength }">最晚开票日</span>
                      <div slot="content" v-html="tipText3"></div>
                    </el-tooltip>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="最晚发货日" prop="latestShipmentDate"
                  ><template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText1>propLength }">最晚发货日</span>
                      <div slot="content" v-html="tipText5"></div>
                    </el-tooltip>
                  </template>
                  <el-date-picker
                    type="date"
                    v-model="form.latestShipmentDate"
                    format="yyyy-MM-dd"
                    style="width: 100%"
                    placeholder="请选择最晚发货日"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="最晚提货天数" prop="latestPickUpFate">
                  <inputNumber
                    v-model="form.latestPickUpFate"
                    :controls="false"
                    class="inputWidth"
                    append="天"
                    :min="-99999999999999999"
                    :max="99999999999999999"
                  ></inputNumber>
                  <template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText2>propLength }">最晚提货天数</span>
                      <div slot="content" v-html="tipText6"></div>
                    </el-tooltip>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="最晚应付结算日" prop="latestPayableSettlementFate">
                  <inputNumber
                    v-model="form.latestPayableSettlementFate"
                    :controls="false"
                    class="inputWidth"
                    append="天"
                    :min="-99999999999999999"
                    :max="99999999999999999"
                  ></inputNumber>
                  <template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText1>propLength }">最晚应付结算日</span>
                      <div slot="content" v-html="tipText7"></div>
                    </el-tooltip>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="回票日期" prop="replyInvoiceFate" :span="6">
                  <inputNumber
                    v-model="form.replyInvoiceFate"
                    :controls="false"
                    class="inputWidth"
                    append="天"
                    :min="-99999999999999999"
                    :max="99999999999999999"
                  ></inputNumber>
                  <template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText1>propLength }">回票日期</span>
                      <div slot="content" v-html="tipText4"></div>
                    </el-tooltip>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="结算日" prop="settlementDate" :span="6">
                  <el-select v-model="form.settlementDate" placeholder="请选择">
                    <el-option
                      v-for="item in dictListMap?.settlementDate"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>

                  <template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText1>propLength }">结算日</span>
                      <div slot="content" v-html="tipText4"></div>
                    </el-tooltip>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="逾期周期" prop="overduePeriod" :span="6">
                  <inputNumber
                    v-model="form.overduePeriod"
                    :controls="false"
                    class="inputWidth"
                    :precision="2"
                    append="天"
                    :min="-99999999999999999"
                    :max="99999999999999999"
                  ></inputNumber>
                  <template slot="label">
                    <el-tooltip placement="top" effect="dark">
                      <span ::class="{ propClass: tipText1>propLength }">逾期周期</span>
                      <div slot="content" v-html="tipText4"></div>
                    </el-tooltip>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            交易明细
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs type="card" v-model="tabActiveName" class="common-tab">
            <el-tab-pane label="商品明细" name="first">
              <div class="detail">
                <GoodsDetailTable
                  ref="goodsDetailTableRef"
                  :fetchTableData="sbOrderDetailDTOList"
                  :contractStatus="contractStatus"
                  @closeTableHandler="closeTableHandler"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="回款约定" name="second">
              <div class="detail">
                <DynamicForm
                  ref="orderReturnAppointmentListRef"
                  key1="returnedRatio"
                  key2="returnedRemind"
                  :isRequiredKey1="false"
                  :isRequiredKey2="false"
                  errorMessage="请补充回款约定"
                  :initFormData="orderReturnAppointmentList"
                  :isDisabled="disableBaseFormData"
                />
              </div>
            </el-tab-pane>
            <el-tab-pane label="付款约定" name="thirdly">
              <div class="detail">
                <DynamicForm
                  ref="orderPayAppointmentListRef"
                  text1Message="付款比例"
                  text2Message="付款提醒"
                  :isRequiredKey1="false"
                  :isRequiredKey2="false"
                  key1="paymentRatio"
                  key2="paymentRemind"
                  errorMessage="请补充付款约定"
                  :initFormData="orderPayAppointmentList"
                  :isDisabled="disableBaseFormData"
                />
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <el-collapse-item name="3">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="collapse-content">
          <FileTable ref="fileTableRef" :attachments="attachments" :isShowDownBtn="isShowDownBtn" />
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮 -->
    <FooterButtons @btnHandler="btnHandler" :contractStatus="contractStatus" />
  </div>
</template>

<script>
  import { formColumns, baseRules } from './index.js';
  import FooterButtons from './components/FooterButtons/index.vue';
  import GoodsDetailTable from './components/GoodsDetailTable/index.vue';
  import BASE_API from '@/api/dataBase.js';
  import DynamicForm from './../../components/DynamicForm/index.vue';
  import bilateralContractApi from '@/api/purchaseSalesCenter/bilateralContract.js';
  import { formatDate, mapNumToString } from '@/utils';
  import btnMix from './btnMix.js';
  export default {
    name: 'bilateralContractCreate',
    mixins: [btnMix],
    data() {
      return {
        activeCollapses: ['1', '2', '3'],
        baseInfoData: {
          contractCreateDate: '',
          contractNo: '',
          contractName: '',
          contractStatus: '',
          companyCode: '',
          companyName: '',
          departmentCode: '',
          departmentName: '',
          projectInitiationNo: '',
          projectName: '',
          supplierNo: '',
          supplierName: '',
          customerNo: '',
          customerName: '',
          contractOperaterNo: '',
          contractOperaterName: '',
          contractSalesmanName: '',
          contractSalesmanNo: '',
          signDate: '',
          contractValidStart: '',
          contractValidEnd: '',
          incomeMethod: '',
          replyInvoiceDate: '',
          isDefault: '0',
          liquidatedDamagesType: '',
          liquidatedDamagesName: '',
          liquidatedFixedValue: '',
          liquidatedInterestRate: '',
          overShippedPercentage: '',
          shortShippedPercentage: '',
          cgExternalContractNo: '',
          cgContractCurrencyName: '',
          lastestPayMoneyDay: '',
          lastestReceiveProductDay: '',
          isPrepay: '0',
          cgReceiptMethod: '',
          cgReceiptMethodName: '',
          receiptConditionName: '',
          ssExternalContractNo: '',
          ssExternalContractName: '',
          overduePeriod: '',
          settlementDate: '0',
          qualityGuaranteeDepositMethodCode: '',
          qualityGuaranteeDepositMethodName: '',
          chargeFixedValue: '',
          chargeProportion: '',
          marginAmount: '',
          creditAmount: '',
          purchaseQuantity: '',
          cgContractCurrency: '',
          ssContractCurrency: '',
          isRestrict: '',
          isLongRange: '',
          ssReceiptMethod: '',
          ssReceiptMethodName: '',
          qualityGuaranteeDepositOverdue: '',
        },
        id: null,
        status: '',
        companyList: [],
        departmentList: [],
        tabActiveName: 'first',
        contractStatus: '', // 单据当前 状态
        isShowDownBtn: false,
        disableBaseFormData: false,
        isFromService: false,
        liquidatedDamagesTypeList: [
          { value: '01', label: '按利率' },
          { value: '02', label: '按固定值' },
        ],
        qualityGuaranteeDepositMethodCodeList: [
          { value: '01', label: '固定金额' },
          { value: '02', label: '结算开票金额比例' },
        ],
        attachments: [],
        sbOrderDetailDTOList: [],
        orderReturnAppointmentList: [],
        orderPayAppointmentList: [],
        form: {}, //逾期预警字段
        propLength: 13,
        tipText1: '业务员选择最晚日期后，到日期<br>后系统在首页进行提醒-出库',
        tipText2:
          '业务员填写最晚结算日天数后，进行<br>出库操作工作后，若经过填写天数<br>后，未进行结算操作，系统在首页进行提醒-应收结算单',
        tipText3:
          '业务员填写最晚开票日天数后，进行结算<br>操作动作后，经过填写天数后，未进行开票<br>操作，系统在首页进行提醒-开票',
        tipText4: '业务员选择结算日后，填写逾期<br>周期后，到日期后系统在首页进行<br>提醒-收款',
        isDisabledForm: false,
        tipText5: '业务员选择最晚日期后，到日期<br>后系统在首页进行提醒-入库',
        tipText6:
          '业务员填写最晚提货天数后，进行<br>入库操作工作后，若经过填写的天数<br>后，系统在首页进行提醒-库存',
        tipText7:
          '业务员填写最晚结算日天数后，进行入库<br>操作动作后，经过填写天数后，未进行结算<br>操作，系统在首页进行提醒-应付结算单',
        tipText8: '业务员填写回票日期天数后，结<br>算单生效后，系统在首页进行<br>提醒-进项发票',
      };
    },
    computed: {
      getReceiptStatusName() {
        return this.getStatusName(this.baseInfoData.receiptStatus);
      },
      baseColumns() {
        return formColumns(this);
      },
      baseRules() {
        return baseRules(this);
      },
    },
    mounted() {
      if (this.$route.query?.status == 'create') {
        this.initFormData();
      }
      if (['copy', 'detail'].includes(this.$route.query?.status)) {
        this.getDetailByContractNo();
      }
      this.id = this.$route.query?.id;
      this.$nextTick(() => {
        this._getCompanyApi();
      });
    },
    methods: {
      initFormData() {
        this.baseInfoData = {
          ...this.baseInfoData,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          contractOperaterName: this.userInfo.userName,
          contractOperaterNo: this.userInfo.userCode,
          contractCreateDate: formatDate(new Date()),
          incomeMethod: '01',
          slipDate: '01',
          overduePeriod: '90',
          cgContractCurrency: 'CNY',
          ssContractCurrency: 'CNY',
        };
      },
      closeTableHandler(tableDataList) {
        console.log(tableDataList);
        const purchaseQuantity = tableDataList.reduce(
          (pre, item) => pre + +item.productQuantity,
          0
        );
        this.baseInfoData.purchaseQuantity =
          purchaseQuantity + '' == 'NaN' ? '0' : purchaseQuantity + '';
      },
      // 根据合同号获取详情信息
      async getDetailByContractNo() {
        const contractNo = this.$route.query?.contractNo;
        if (!contractNo) {
          this.$message.error('请传递合同号');
          return;
        }
        const { data } = await this.$axios.post(
          `${bilateralContractApi.GET_DETAIL_BY_CONTRACT_NO}/${contractNo}`
        );
        if (data.code == 0) {
          console.log(data, '???', data.data.contractNo);
          // 1.表单数据
          const {
            latestPickUpDate,
            latestReceivableSettlementFate,
            latestInvoiceFate,
            latestShipmentDate,
            latestPickUpFate,
            latestPayableSettlementFate,
            replyInvoiceFate,
            overduePeriod,
            settlementDate,
            basefromdata,
          } = data.data;
          console.log(basefromdata);
          const form = {
            latestPickUpDate,
            latestReceivableSettlementFate,
            latestInvoiceFate,
            latestShipmentDate,
            latestPickUpFate,
            latestPayableSettlementFate,
            replyInvoiceFate,
            overduePeriod,
            settlementDate,
          };
          this.form = { ...mapNumToString(form) };
          this.baseInfoData = {
            ...this.baseInfoData,
            ...mapNumToString(data.data),
            isDefault: data.data.isDefault ? '1' : '0',
            contractNo: this.$route.query?.status == 'copy' ? '' : data.data.contractNo,
          };
          // 2.表格数据
          this.sbOrderDetailDTOList = data.data?.sbOrderDetailDTOList || [];
          // 3.回款约定
          this.orderReturnAppointmentList = data.data?.orderReturnAppointmentList || [];
          // 4.付款约定
          this.orderPayAppointmentList = data.data?.orderPayAppointmentList || [];
          // 5.附件
          this.attachments = data.data?.attachmentList || [];
          if (this.$route.query.status != 'copy') {
            const contractStatus = data.data?.contractStatus;
            this.contractStatus = contractStatus;
            /**
             * 'ZT00', 'ZT05', 'ZT06'
             * 'ZT02', 'ZT023', 'ZT024', 'ZT025', 'ZT021' 审批中
             * ZT03 已生效
             * ZT022 撤回审批中
             * ZT061 修订中
             * ZT051 修订已驳回
             * ZT07 已关闭
             */
            if (contractStatus) {
              if (
                ['ZT03', 'ZT02', 'ZT021', 'ZT023', 'ZT024', 'ZT025', 'ZT022'].includes(
                  contractStatus
                )
              ) {
                this.isShowDownBtn = true;
                this.disableBaseFormData = true;
              }
            }
          }
        } else {
          this.$message.error('根据合同号获取合同详情失败');
        }
      },
      // 获取公司
      async _getCompanyApi() {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        if (data.code == 0) {
          this.companyList = data.data?.personCompanyInfo;
          this._getDepartmentByCompanyCodeApi(this.baseInfoData.companyCode);
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode) {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        });
        if (data.code == 0) {
          this.departmentList = data.data?.personDepartmentInfo;
        } else {
          console.error('获取部门失败');
        }
      },
    },
    components: {
      FooterButtons,
      DynamicForm,
      GoodsDetailTable,
    },
  };
</script>

<style lang="scss" scoped></style>
